import { requireNativeViewManager } from 'expo-modules-core';

export const NativeBlurView = requireNativeViewManager('ExpoBlur', 'ExpoBlurView');

export const NativeBlurTargetView = requireNativeViewManager('ExpoBlur', 'ExpoBlurTargetView');
